import { render, staticRenderFns } from "./no-results.vue?vue&type=template&id=36ea31e6&"
import script from "./no-results.vue?vue&type=script&lang=js&"
export * from "./no-results.vue?vue&type=script&lang=js&"
import style0 from "./no-results.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports